import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    success: {
      main: '#4caf50',
      light: '#d7ffd9',
      dark: '#087f23',
    },
    error: {
      main: '#f44336',
      light: '#ffd9d9',
      dark: '#b71c1c',
    },
    warning: {
      main: '#ff9800',
      light: '#fff3e0',
      dark: '#e65100',
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
